import { useState } from 'react';
import { TrackingEvents, TrackingTabs, useTrack } from '../../tracking';
import { useNewTranslations } from '@/common/translations';
import type { Option } from '@/common/types';
import { Filter, ShotsChart } from '@/ui/components';
import { StatsShotsChartOptions } from '../../constants';
import type { StatsShotsChartOption } from '../../types';
import type { StatsShotsChartProps } from './StatsShotsChart.types';

export default function StatsShotsChart(props: StatsShotsChartProps) {
  const {
    className = '',
    homeOffTarget = 0,
    homeConcededOffTarget = 0,
    homeOnTarget = 0,
    homeConcededOnTarget = 0,
    awayOffTarget = 0,
    awayConcededOffTarget = 0,
    awayOnTarget = 0,
    awayConcededOnTarget = 0,
  } = props;

  const [filterValue, setFilterValue] = useState<StatsShotsChartOption>(
    StatsShotsChartOptions.ON_OFF,
  );

  const translate = useNewTranslations();
  const track = useTrack();

  let displayedHomeOffTarget = homeOffTarget;
  let displayedHomeOnTarget = homeOnTarget;
  let displayedAwayOnTarget = awayOnTarget;
  let displayedAwayOffTarget = awayOffTarget;

  if (filterValue === StatsShotsChartOptions.CONCEDED) {
    displayedHomeOffTarget = homeConcededOffTarget;
    displayedHomeOnTarget = homeConcededOnTarget;
    displayedAwayOnTarget = awayConcededOnTarget;
    displayedAwayOffTarget = awayConcededOffTarget;
  }

  const filterOptions: Option<StatsShotsChartOption>[] = [
    { label: translate('PreMatchStats.On&OffGame'), value: StatsShotsChartOptions.ON_OFF },
    { label: translate('PreMatchStats.ConcededGame'), value: StatsShotsChartOptions.CONCEDED },
  ];

  const handleFilterChange = (value: StatsShotsChartOption) => {
    const elementOrder = filterOptions.findIndex((option) => option.value === value) + 1;
    track(TrackingEvents.FilterClick, {
      tab: TrackingTabs.Stats,
      filter: value,
      elementOrder,
    });
    setFilterValue(value);
  };

  return (
    <div className={`flex flex-col gap-[16px] ${className}`}>
      <Filter options={filterOptions} value={filterValue} onValueChange={handleFilterChange} />
      <ShotsChart
        homeOffTarget={displayedHomeOffTarget}
        homeOnTarget={displayedHomeOnTarget}
        awayOnTarget={displayedAwayOnTarget}
        awayOffTarget={displayedAwayOffTarget}
      />
    </div>
  );
}
